var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIprsSymbolBgwhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "content-boxes__box-svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43.288,
    height: 43.348,
    viewBox: "0 0 43.288 43.348",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 7.261,
    y1: -65.734,
    x2: 8.263,
    y2: -65.734,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d1659f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#c83883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a93c85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 11.024,
    y1: -68.621,
    x2: 12.023,
    y2: -68.621,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dcdf93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#bbc85f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86a433"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_285",
    "data-name": "Group 285",
    transform: "translate(-422.376 -359.626)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M550.552,266.858a4.266,4.266,0,0,0-4.26,4.247v.194a4.313,4.313,0,0,0,4.248,4.26c2.266,0,7.094-.133,10.249,3.022s2.8,7.721,2.8,10.066a4.265,4.265,0,0,0,4.247,4.26h.194a4.267,4.267,0,0,0,4.26-4.248v-9.537c0-9.161-3.454-12.264-10.152-12.264Z",
    transform: "translate(-123.915 110.067)",
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M596.652,264.227a4.244,4.244,0,0,0,4.26-4.221v-.193a4.27,4.27,0,0,0-4.247-4.26c-2.33,0-7.6.513-10.759-2.642-2.788-2.787-2.29-8.057-2.29-10.445a4.238,4.238,0,0,0-4.247-4.26h-.193a4.29,4.29,0,0,0-4.288,4.247v9.537c0,9.16,3.479,12.238,10.178,12.238Z",
    transform: "translate(-135.248 121.422)",
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIprsSymbolBgwhite);
export default __webpack_public_path__ + "static/media/IPRS_symbol_bgwhite.db4c44a19b6d1a047e7022d89d10cabb.svg";
export { ForwardRef as ReactComponent };